<template>
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path :fill="fill || 'white'" fill-rule="evenodd" clip-rule="evenodd" d="M10.5236 2.74619C11.7151 1.93096 13.2849 1.93096 14.4764 2.74619L20.9764 7.19356C21.9299 7.84595 22.5 8.92683 22.5 10.0822L20.5 18.4998C20 20.5 18.933 21.9998 17 21.9998H8C6.067 21.9998 5 20.5 4.5 18.4998L2.5 10.0822C2.5 8.92683 3.07012 7.84595 4.02361 7.19356L10.5236 2.74619ZM10 17.4998C9.72386 17.4998 9.5 17.7237 9.5 17.9998C9.5 18.2759 9.72386 18.4998 10 18.4998H15C15.2761 18.4998 15.5 18.2759 15.5 17.9998C15.5 17.7237 15.2761 17.4998 15 17.4998H10Z" />
  </svg>
</template>

<script>
export default {
  props: [
    'fill'
  ],
}
</script>